import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { NgxsModule } from "@ngxs/store";
import { ValidatorsModule } from "@vattenfall/core";
import { PipesModule } from "@vattenfall/core";
import { ButtonModule, ErrorModule, FieldsetModule, InputModule, LoadingModule } from "@vattenfall/ui";

import { FlowsMoveAcquisitionPrivateSwitchElement } from "./flows-move-acquisition-private-switch.element";
import { FlowsMoveAcquisitionPrivateSwitchState } from "./flows-move-acquisition-private-switch.state";
import { SvgAppartmentAnimationComponent } from "./svg-appartment-animation/svg-appartment-animation.component";
import { SvgVillaAnimationComponent } from "./svg-villa-animation/svg-villa-animation.component";
import { VfInputRangeSliderComponent } from "./vf-input-range-slider/vf-input-range-slider.component";

@NgModule({
  declarations: [
    FlowsMoveAcquisitionPrivateSwitchElement,
    SvgAppartmentAnimationComponent,
    SvgVillaAnimationComponent,
    VfInputRangeSliderComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ValidatorsModule,
    ErrorModule,
    FieldsetModule,
    LoadingModule,
    InputModule,
    ButtonModule,
    PipesModule,
    NgxsModule.forFeature([FlowsMoveAcquisitionPrivateSwitchState]),
  ],
  bootstrap: [FlowsMoveAcquisitionPrivateSwitchElement],
  exports: [FlowsMoveAcquisitionPrivateSwitchElement],
})
export class FlowsMoveAcquisitionPrivateSwitchModule {}
